import {
  NomenclatureTransferCreateScreen,
  NomenclatureTransferDetailScreen,
  NomenclatureTransferListScreen,
} from 'pages/ComingMaterials';

import {
  CarrierReport,
  ComingFare,
  ComingNomenclature,
  ComingNomenclatureAdjustmentDetail,
  ComingNomenclatureDetail,
  ConsumptionNomenclature,
  InitialBalance,
  MaterialBalance,
} from '../../pages';

export const routingMaterialFlow = [
  {
    path: '/comming-materials',
    exact: true,
    component: ComingNomenclature,
    claims: ['CanLookComingMaterialSection'],
  },
  {
    path: '/comming/add',
    exact: true,
    component: ComingNomenclatureDetail,
    claims: ['CanLookComingMaterialSection'],
  },
  {
    path: '/comming-materials/:id',
    exact: true,
    component: ComingNomenclatureDetail,
    claims: ['CanLookComingMaterialSection'],
  },

  {
    path: '/comming-materials/:id',
    exact: true,
    component: ConsumptionNomenclature,
    claims: ['CanLookComingMaterialSection'],
  },
  {
    path: '/expense-materials',
    exact: true,
    component: ConsumptionNomenclature,
    claims: ['CanLookConsumptionNomenclatureSection'],
  },
  {
    path: '/comming-fare',
    exact: true,
    component: ComingFare,
    claims: ['CanLookPassCalculationSection'],
  },
  {
    path: '/comming-fare-adjustment/:id',
    exact: true,
    component: ComingNomenclatureAdjustmentDetail,
    claims: ['CanLookPassCalculationSection'],
  },
  {
    path: '/career-reconciliation',
    exact: true,
    component: CarrierReport,
    claims: ['CanLookCareerReportSection'],
  },
  {
    path: '/initial-balance',
    exact: true,
    component: InitialBalance,
    claims: ['CanLookAndEditStartMaterialRemains'],
  },
  {
    path: '/consumption',
    exact: true,
    component: MaterialBalance,
    claims: ['all'],
  },
  {
    path: '/nomenclatureTransferList',
    exact: true,
    component: NomenclatureTransferListScreen,
    claims: ['CanLookNomenclatureTransferSection'],
  },
  {
    path: '/nomenclature-transfer-add',
    exact: true,
    component: NomenclatureTransferCreateScreen,
    claims: ['CanEditNomenclatureTransferSection'],
  },
  {
    path: '/nomenclature-transfer/:id',
    exact: true,
    component: NomenclatureTransferDetailScreen,
    claims: ['CanLookNomenclatureTransferSection'],
  },
];
